import moment from 'jalali-moment';

export default function timeStampToDate(
  timestamp: number | string | null | undefined
): string {
  try {
    if (timestamp) {
      const m = moment(Number(timestamp) * 1000);
      return m.locale('fa').format('HH:mm:ss YYYY-MM-DD');
    }
    return '';
  } catch (err) {
    console.error('Error timeStampToDate:', err);
    return '-';
  }
}
